export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <path d="M5 7l11 19L27 7" stroke="#FF4D00" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5 7L16 15.4 20.5 7" stroke="#F9FAFB" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" />
  </svg>
);

const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-syne font-extrabold tracking-tight text-lg leading-none text-white">
      VIBERA
      <span className="ml-2 font-mono text-[10px] font-medium tracking-[0.35em] text-white/50 align-middle">
        GROUP
      </span>
    </span>
  </span>
);

export default Logo;
